define('lib/terms/ClientTermsController',['require','model/ClientTermsModel','view/module/ClientTermsView','view/module/PromoAlertView','model/LicenseModel','model/TermsAndConditionsModel'],function (require) {

    var ClientTermsModel = require('model/ClientTermsModel');
    var ClientTermsView = require('view/module/ClientTermsView');
    var PromoAlertView = require('view/module/PromoAlertView');
    var LicenseModel = require('model/LicenseModel');
    var TermsAndConditionsModel = require('model/TermsAndConditionsModel');

    return Marionette.Object.extend({

        _termsAndConditions: null,
        _clientModel: null,
        _model: null,
        _termsAndConditionsModel: null,
        _userTermsAndConditionsModel: null,
        _privacyPolicyModel: null,
        _cancellationPolicyModel: null,
        _view: null,

        initialize: function () {
            this._clientModel = this.getOption('client');

            this._initModel();
        },

        _initModel: function () {
            this._model = new ClientTermsModel();
            this.listenTo(this._clientModel, 'sync', this._updateClientTerms);

            if (this._clientModel.get('id')) {
                this._model.fetch();
            }

            //TODO remove after finished refactoring
            // var termsAndConditionsModel = LicenseModel.extend({
            //     url: '/license'
            // });

            var lang = Config.getInstance().getOption('company_language');
            if (lang == 'pl') lang = 'en'; //TODO remove after polish translation is updated on the main site
            this._termsAndConditionsModel = new TermsAndConditionsModel(null, {
                lang: lang
            });
            this._termsAndConditionsModel.fetch();

            if (this._model.getTermsAndConditions().isCancellationPolicyVisible()) {
                var cancellationPolicyModel = LicenseModel.extend({
                    url: '/license/cancellation-policy'
                });
                this._cancellationPolicyModel = new cancellationPolicyModel();
                this._cancellationPolicyModel.fetch();
            }

            if (this._model.getTermsAndConditions().isUserTermsAndConditionsVisible()) {
                var userTermsAndConditionsModel = LicenseModel.extend({
                    url: '/license/user'
                });
                this._userTermsAndConditionsModel = new userTermsAndConditionsModel();
                this._userTermsAndConditionsModel.fetch();
            }

            if (this._model.getTermsAndConditions().isPrivacyPolicyVisible()) {
                var privacyPolicyModel = LicenseModel.extend({
                    url: '/license/privacy-policy'
                });
                this._privacyPolicyModel = new privacyPolicyModel();
                this._privacyPolicyModel.fetch();
            }
        },

        _updateClientTerms: function () {
            this._model.fetch();
        },

        getModel: function () {
            return this._model;
        },

        getView: function () {
            if (!this._view || this._view.isDestroyed) {
                this._view = new ClientTermsView({
                    model: this._model,
                    termsAndConditionsModel: this._termsAndConditionsModel,
                    cancellationPolicyModel: this._cancellationPolicyModel,
                    userTermsAndConditionsModel: this._userTermsAndConditionsModel,
                    privacyPolicyModel: this._privacyPolicyModel
                });
            }
            return this._view;
        },

        getPromoAlertView: function (){
            if (!this._alertView || this._alertView.isDestroyed) {
                this._alertView = new PromoAlertView({
                    model: this._model,
                    termsAndConditionsModel: this._termsAndConditionsModel,
                    cancellationPolicyModel: this._cancellationPolicyModel,
                    userTermsAndConditionsModel: this._userTermsAndConditionsModel,
                    privacyPolicyModel: this._privacyPolicyModel
                });
            }
            return this._alertView;
        },

        validate: function () {
            return this._model.isValid();
        }

    }, {

        _instance: null,

        getInstance: function (options) {
            if (!this._instance) {
                this._instance = new this(options);
            }
            return this._instance;
        }

    });

});
